export default "__VITE_ASSET__CnWPCkaG__"